import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { DateDiffModel } from 'src/app/models/inputs/date-diff-model';
import { DateModel } from 'src/app/models/inputs/date-model';

@Injectable()
export class DateDifferenceService {

  constructor(
    private translate: TranslateService
  ) { }

  newMomentByDateModel(date: DateModel, isQuickQuotek?: boolean) {
    if(!date) return;
    if(isQuickQuotek){
      return moment(new Date(+date.year - (this.translate.currentLang === 'en' ? 0 : 0), +date.month - 1, +date.day));
    } else {
      return moment(new Date(+date.year - (this.translate.currentLang === 'en' ? 0 : 543), +date.month - 1, +date.day));
    }
  }

  diffCurrentDate(date: any, type: 'date' | 'obj', isQuickQuotek?: boolean): DateDiffModel {
    let start;
    // set start date
    if ((date instanceof Date) && type === 'date') {
      start = moment(date);
    } else if (date instanceof DateModel || type === 'obj') {
      start = this.newMomentByDateModel(date,isQuickQuotek);
    } else {
      try {
        start = moment(new Date(date));
      } catch (e) {
        start = null;
      }
    }

    start = start != 'Invalid Date' ? start : null;
    return this.diffCurrent(start);
  }

  diffCurrent(start: any): DateDiffModel {
    const end = moment();
    return this.diff(start, end);
  }

  diff(start: any, end: any): DateDiffModel {
    if (start && start.isValid() && end && end.isValid()) {
      const years = end.diff(start, 'years');
      const months = end.diff(start, 'months') - (years * 12);
      start.add(years, 'years').add(months, 'months');
      const days = end.diff(start, 'days');
      return { years, months, days };
    }
    return { years: 0, months: 0, days: 0 };
  }
}
